import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

/** Invite copy uses primary text in both modes; emphasis is bold, not a second color. */
export const inviteTextSx: SxProps<Theme> = {
  color: "text.primary",
};

export const inviteTextBoldSx: SxProps<Theme> = {
  color: "text.primary",
  fontWeight: 700,
};

export const inviteLinkSx: SxProps<Theme> = {
  color: "text.primary",
  fontWeight: 700,
  textDecorationColor: "inherit",
};

export const inviteCalloutSurfaceSx = (
  theme: Theme,
  variant: "neutral" | "caution" | "error",
) => {
  const base = {
    border: `1px solid ${theme.palette.divider}`,
    bgcolor: theme.palette.surfaceMuted,
  };

  if (variant === "error") {
    return {
      ...base,
      borderColor: alpha(theme.palette.error.main, 0.35),
      bgcolor: alpha(theme.palette.error.main, 0.06),
    };
  }

  return base;
};

export const inviteIconSx: SxProps<Theme> = {
  color: "text.primary",
};

export const inviteOutlinedButtonSx = (theme: Theme) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  borderColor: theme.palette.divider,
  "&:hover": {
    borderColor: theme.palette.text.primary,
    bgcolor: theme.palette.action.hover,
  },
  "&.Mui-disabled": {
    borderColor: theme.palette.divider,
    color: theme.palette.text.disabled,
  },
});
